export class SliderListStyle {
  columnGap = '';
  showDividers = '';

  static normalize(styles: Partial<SliderListStyle>): SliderListStyle {
    const pureStyles = new SliderListStyle();

    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;
    pureStyles.showDividers = styles.showDividers ?? pureStyles.showDividers;

    return pureStyles;
  }
}
